module.exports = __webpack_public_path__ + "img/Element-Overlay-Incorrect.8736a24b.svg";